import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "@/App";
import { AuthProvider } from "@/auth/AuthProvider";
import { configureAmplify } from "@/auth/amplify";
import { initAnalytics } from "@/analytics";
import { startThemeSchedule } from "@/lib/theme";
import "@/styles/globals.css";

configureAmplify();
initAnalytics();
// Applied before first paint so the app never flashes light then swaps to dark.
startThemeSchedule();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
